.root {
  font-size: var(--font-size-body-2);
  font-weight: var(--font-weight-regular);
  color: var(--blue-700);
  letter-spacing: var(--font-small-letter-spacing);

  &:active {
    border: none;
  }
}
